const S = {
  wrapper:      { marginTop:'10px', padding:'40px', border:'3px solid grey', fontFamily:"'Georgia', serif", color:'#1a1a2e', lineHeight:'1.7' },
  h1:           { fontSize:'2rem', fontWeight:'700', borderBottom:'3px solid #2E75B6', paddingBottom:'8px', marginBottom:'24px', color:'#1F3864' },
  h2:           { fontSize:'1.3rem', fontWeight:'700', color:'#2E75B6', marginTop:'36px', marginBottom:'12px', borderLeft:'4px solid #2E75B6', paddingLeft:'10px' },
  p:            { marginBottom:'12px', fontSize:'0.97rem' },
  infoBox:      { background:'#EBF3FB', border:'2px solid #2E75B6', borderRadius:'6px', padding:'16px 20px', margin:'16px 0' },
  infoBoxTitle: { fontWeight:'700', fontFamily:"'Courier New', monospace", fontSize:'0.88rem', color:'#1F3864', marginBottom:'8px' },
  infoBoxItem:  { fontSize:'0.9rem', margin:'4px 0', paddingLeft:'12px', borderLeft:'2px solid #2E75B6' },
  table:        { width:'100%', borderCollapse:'collapse', marginBottom:'20px', fontSize:'0.92rem' },
  th:           { background:'#2E75B6', color:'#fff', padding:'10px 14px', textAlign:'left', fontWeight:'700', fontSize:'0.9rem' },
  tdE:          { padding:'10px 14px', borderBottom:'1px solid #ccd9ea', verticalAlign:'top', background:'#f5f9ff' },
  tdO:          { padding:'10px 14px', borderBottom:'1px solid #ccd9ea', verticalAlign:'top', background:'#fff' },
  tdL:          { fontWeight:'600', color:'#1F3864', whiteSpace:'nowrap', width:'220px' },
  code:         { fontFamily:"'Courier New', monospace", fontSize:'0.88rem', whiteSpace:'pre-wrap' },
  dWrap:        { margin:'24px 0', background:'#f8fbff', border:'1px solid #ccd9ea', borderRadius:'8px', padding:'20px' },
  dTitle:       { fontWeight:'700', fontSize:'0.95rem', color:'#1F3864', marginBottom:'12px', textAlign:'center', letterSpacing:'0.02em' },
  dCaption:     { fontSize:'0.84rem', color:'#555', textAlign:'center', marginTop:'10px', fontStyle:'italic' },
};

function InfoBox({ title, items }) {
  return (
    <div style={S.infoBox}>
      <div style={S.infoBoxTitle}>{title}</div>
      {items.map((item, i) => <div key={i} style={S.infoBoxItem}>{item}</div>)}
    </div>
  );
}

function Table2({ rows }) {
  return (
    <table style={S.table}>
      <thead><tr>
        <th style={{ ...S.th, width:'220px' }}>Concept</th>
        <th style={S.th}>Formula / Notes</th>
      </tr></thead>
      <tbody>
        {rows.map(([label, content], i) => (
          <tr key={i}>
            <td style={{ ...(i%2===0?S.tdE:S.tdO), ...S.tdL }}>{label}</td>
            <td style={{ ...(i%2===0?S.tdE:S.tdO), ...S.code }}>{content}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

// ── Diagram 1: Truth Tables for All Basic Connectives ───────────
function DiagramTruthTables() {
  const W = 900, H = 320;

  // Six connectives: NOT(p), AND, OR, XOR, NAND, NOR
  // Layout: NOT gets one column (only p), others get two inputs
  // We'll do two rows: top = NOT / AND / OR  bottom = XOR / NAND / NOR
  // Each table: 90px wide, rows for each input combo

  const colW = 136, colGap = 14;
  const startX = 14;
  const rowH = 26, hdrH = 30;

  // NOT: 1 input
  const notRows = [
    { p:0, out:1 },
    { p:1, out:0 },
  ];

  // 2-input tables
  const twoRows = [
    { p:0, q:0 },
    { p:0, q:1 },
    { p:1, q:0 },
    { p:1, q:1 },
  ];

  const ops = [
    { name:'AND',  sym:'p \u2227 q',   fn:(p,q)=>p&&q?1:0,   color:'#2E75B6', bg:'#EBF3FB', bc:'#2E75B6' },
    { name:'OR',   sym:'p \u2228 q',   fn:(p,q)=>p||q?1:0,   color:'#27ae60', bg:'#f0fff4', bc:'#27ae60' },
    { name:'XOR',  sym:'p \u2295 q',   fn:(p,q)=>p!==q?1:0,  color:'#e07b00', bg:'#fff7ee', bc:'#e07b00' },
    { name:'NAND', sym:'\u00ac(p\u2227q)', fn:(p,q)=>!(p&&q)?1:0, color:'#c0392b', bg:'#fff0f0', bc:'#c0392b' },
    { name:'NOR',  sym:'\u00ac(p\u2228q)', fn:(p,q)=>!(p||q)?1:0, color:'#9b59b6', bg:'#f5d0ff', bc:'#9b59b6' },
    { name:'XNOR', sym:'p \u2261 q',   fn:(p,q)=>p===q?1:0,  color:'#1F3864', bg:'#e8eaf6', bc:'#1F3864' },
  ];

  function TruthTable({ x, y, name, sym, rows, color, bg, bc, cols }) {
    const cw = (colW - 4) / cols.length;
    const tableH = hdrH + rows.length * rowH + 4;
    return (
      <g>
        {/* Header background */}
        <rect x={x} y={y} width={colW} height={tableH + 20} rx={4} fill="#fff" stroke="#ccd9ea" strokeWidth="1"/>
        <rect x={x} y={y} width={colW} height={28} rx={4} fill={color}/>
        <rect x={x} y={y+20} width={colW} height={8} fill={color}/>
        <text x={x + colW/2} y={y+18} textAnchor="middle" fontSize="12" fill="#fff" fontWeight="700">{name}: {sym}</text>
        {/* Column headers */}
        {cols.map((c, ci) => (
          <text key={ci} x={x + ci*cw + cw/2} y={y+hdrH+4} textAnchor="middle"
            fontSize="11" fill={color} fontWeight="700" fontFamily="'Courier New',monospace">{c}</text>
        ))}
        {/* Divider */}
        <line x1={x+2} y1={y+hdrH+8} x2={x+colW-2} y2={y+hdrH+8} stroke="#ddd" strokeWidth="1"/>
        {/* Data rows */}
        {rows.map((row, ri) => {
          const vals = cols.map(c => {
            if (c==='p') return row.p;
            if (c==='q') return row.q;
            return row.out;
          });
          return vals.map((v, ci) => {
            const isOut = ci === cols.length - 1;
            const fill = isOut ? (v===1 ? '#27ae60' : '#c0392b') : '#555';
            return (
              <text key={`${ri}-${ci}`}
                x={x + ci*cw + cw/2} y={y + hdrH + 8 + (ri+1)*rowH}
                textAnchor="middle" fontSize="12" fill={fill}
                fontFamily="'Courier New',monospace" fontWeight={isOut?'700':'400'}>
                {v}
              </text>
            );
          });
        })}
        {/* Row separator lines */}
        {rows.map((_, ri) => (
          <line key={ri} x1={x+2} y1={y+hdrH+8+(ri+1)*rowH+8}
            x2={x+colW-2} y2={y+hdrH+8+(ri+1)*rowH+8}
            stroke="#f0f0f0" strokeWidth="1"/>
        ))}
      </g>
    );
  }

  // NOT table
  const notData = notRows.map(r => ({ ...r }));
  // Two-input tables
  const twoData = twoRows.map(r => r);

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Truth Tables for All Basic Logical Connectives</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>

        {/* NOT table — placed first, narrower */}
        <g>
          <rect x={14} y={10} width={90} height={132} rx={4} fill="#fff" stroke="#ccd9ea" strokeWidth="1"/>
          <rect x={14} y={10} width={90} height={28} rx={4} fill="#555"/>
          <rect x={14} y={30} width={90} height={8} fill="#555"/>
          <text x={59} y={28} textAnchor="middle" fontSize="12" fill="#fff" fontWeight="700">NOT: ¬p</text>
          {/* col headers */}
          <text x={36} y={52} textAnchor="middle" fontSize="11" fill="#555" fontWeight="700" fontFamily="'Courier New',monospace">p</text>
          <text x={72} y={52} textAnchor="middle" fontSize="11" fill="#555" fontWeight="700" fontFamily="'Courier New',monospace">¬p</text>
          <line x1={16} y1={56} x2={102} y2={56} stroke="#ddd" strokeWidth="1"/>
          {notRows.map((r, ri) => (
            <g key={ri}>
              <text x={36} y={56+(ri+1)*rowH} textAnchor="middle" fontSize="12" fill="#555" fontFamily="'Courier New',monospace">{r.p}</text>
              <text x={72} y={56+(ri+1)*rowH} textAnchor="middle" fontSize="12"
                fill={r.out===1?'#27ae60':'#c0392b'} fontFamily="'Courier New',monospace" fontWeight="700">{r.out}</text>
              <line x1={16} y1={56+(ri+1)*rowH+8} x2={102} y2={56+(ri+1)*rowH+8} stroke="#f0f0f0" strokeWidth="1"/>
            </g>
          ))}
          <text x={59} y={124} textAnchor="middle" fontSize="10" fill="#888">Unary</text>
        </g>

        {/* Six 2-input tables */}
        {ops.map(({ name, sym, fn, color, bg, bc }, i) => {
          const x = 118 + i * (colW + colGap);
          const rowsWithOut = twoData.map(r => ({ ...r, out: fn(r.p, r.q) }));
          return (
            <TruthTable key={i} x={x} y={10}
              name={name} sym={sym}
              rows={rowsWithOut} color={color} bg={bg} bc={bc}
              cols={['p','q','out']}/>
          );
        })}

      </svg>
      <div style={S.dCaption}>Green 1 = true, red 0 = false. AND outputs 1 only when both inputs are 1. OR outputs 1 when at least one is 1. XOR is the "exclusive or" — 1 when inputs differ. NAND and NOR are their negations. XNOR (logical biconditional) is 1 when inputs are equal.</div>
    </div>
  );
}

// ── Diagram 2: Logic Gate Symbols ───────────────────────────────
function DiagramGates() {
  const W = 900, H = 280;

  // Draw 6 gates in a row: NOT, AND, OR, XOR, NAND, NOR
  // Each gate in a box 140px wide

  const gates = [
    { name:'NOT', color:'#555',    inputs:1 },
    { name:'AND', color:'#2E75B6', inputs:2 },
    { name:'OR',  color:'#27ae60', inputs:2 },
    { name:'XOR', color:'#e07b00', inputs:2 },
    { name:'NAND',color:'#c0392b', inputs:2 },
    { name:'NOR', color:'#9b59b6', inputs:2 },
  ];

  const GW = (W - 28) / 6 - 4;  // gate panel width
  const gap = 4;

  // NOT gate (triangle + bubble)
  function GateNOT({ cx, cy, color }) {
    const bx = cx - 28, by = cy;
    return (
      <g>
        {/* Triangle body */}
        <polygon points={`${bx},${by-20} ${bx},${by+20} ${bx+34},${by}`} fill="#f8fbff" stroke={color} strokeWidth="2"/>
        {/* Bubble */}
        <circle cx={bx+39} cy={by} r={5} fill="#fff" stroke={color} strokeWidth="2"/>
        {/* Input wire */}
        <line x1={bx-16} y1={by} x2={bx} y2={by} stroke={color} strokeWidth="1.8"/>
        <text x={bx-22} y={by+4} textAnchor="middle" fontSize="11" fill={color} fontWeight="700">p</text>
        {/* Output wire */}
        <line x1={bx+44} y1={by} x2={bx+58} y2={by} stroke={color} strokeWidth="1.8"/>
        <text x={bx+65} y={by+4} textAnchor="middle" fontSize="11" fill={color} fontWeight="700">¬p</text>
      </g>
    );
  }

  // AND gate (flat back + rounded front)
  function GateAND({ cx, cy, color }) {
    const bx = cx - 32, by = cy;
    const gw = 46, gh = 36;
    return (
      <g>
        <path d={`M ${bx},${by-gh/2} L ${bx+gw*0.5},${by-gh/2} A ${gh/2} ${gh/2} 0 0 1 ${bx+gw*0.5},${by+gh/2} L ${bx},${by+gh/2} Z`}
          fill="#f8fbff" stroke={color} strokeWidth="2"/>
        {/* Input wires */}
        <line x1={bx-16} y1={by-10} x2={bx} y2={by-10} stroke={color} strokeWidth="1.8"/>
        <line x1={bx-16} y1={by+10} x2={bx} y2={by+10} stroke={color} strokeWidth="1.8"/>
        <text x={bx-22} y={by-6} textAnchor="middle" fontSize="11" fill={color} fontWeight="700">p</text>
        <text x={bx-22} y={by+14} textAnchor="middle" fontSize="11" fill={color} fontWeight="700">q</text>
        {/* Output wire */}
        <line x1={bx+gw*0.5+gh/2} y1={by} x2={bx+gw*0.5+gh/2+14} y2={by} stroke={color} strokeWidth="1.8"/>
        <text x={bx+gw*0.5+gh/2+22} y={by+4} textAnchor="middle" fontSize="10" fill={color} fontWeight="700">out</text>
      </g>
    );
  }

  // OR gate (curved back + pointed front)
  function GateOR({ cx, cy, color, xorExtra }) {
    const bx = cx - 32, by = cy;
    const gw = 46, gh = 36;
    const cp = gw * 0.45;
    return (
      <g>
        {xorExtra && (
          <path d={`M ${bx-8},${by-gh/2} Q ${bx+cp-8},${by} ${bx-8},${by+gh/2}`}
            fill="none" stroke={color} strokeWidth="2"/>
        )}
        <path d={`M ${bx},${by-gh/2} Q ${bx+cp},${by} ${bx},${by+gh/2} Q ${bx+gw},${by+gh/2} ${bx+gw+gh/2},${by} Q ${bx+gw},${by-gh/2} ${bx},${by-gh/2} Z`}
          fill="#f8fbff" stroke={color} strokeWidth="2"/>
        {/* Input wires */}
        <line x1={bx-16} y1={by-10} x2={bx+4} y2={by-10} stroke={color} strokeWidth="1.8"/>
        <line x1={bx-16} y1={by+10} x2={bx+4} y2={by+10} stroke={color} strokeWidth="1.8"/>
        <text x={bx-22} y={by-6} textAnchor="middle" fontSize="11" fill={color} fontWeight="700">p</text>
        <text x={bx-22} y={by+14} textAnchor="middle" fontSize="11" fill={color} fontWeight="700">q</text>
        {/* Output wire */}
        <line x1={bx+gw+gh/2} y1={by} x2={bx+gw+gh/2+14} y2={by} stroke={color} strokeWidth="1.8"/>
        <text x={bx+gw+gh/2+22} y={by+4} textAnchor="middle" fontSize="10" fill={color} fontWeight="700">out</text>
      </g>
    );
  }

  // NAND = AND + bubble
  function GateNAND({ cx, cy, color }) {
    const bx = cx - 32, by = cy;
    const gw = 42, gh = 36;
    return (
      <g>
        <path d={`M ${bx},${by-gh/2} L ${bx+gw*0.5},${by-gh/2} A ${gh/2} ${gh/2} 0 0 1 ${bx+gw*0.5},${by+gh/2} L ${bx},${by+gh/2} Z`}
          fill="#f8fbff" stroke={color} strokeWidth="2"/>
        <circle cx={bx+gw*0.5+gh/2+5} cy={by} r={5} fill="#fff" stroke={color} strokeWidth="2"/>
        <line x1={bx-16} y1={by-10} x2={bx} y2={by-10} stroke={color} strokeWidth="1.8"/>
        <line x1={bx-16} y1={by+10} x2={bx} y2={by+10} stroke={color} strokeWidth="1.8"/>
        <text x={bx-22} y={by-6} textAnchor="middle" fontSize="11" fill={color} fontWeight="700">p</text>
        <text x={bx-22} y={by+14} textAnchor="middle" fontSize="11" fill={color} fontWeight="700">q</text>
        <line x1={bx+gw*0.5+gh/2+10} y1={by} x2={bx+gw*0.5+gh/2+22} y2={by} stroke={color} strokeWidth="1.8"/>
        <text x={bx+gw*0.5+gh/2+30} y={by+4} textAnchor="middle" fontSize="10" fill={color} fontWeight="700">out</text>
      </g>
    );
  }

  // NOR = OR + bubble
  function GateNOR({ cx, cy, color }) {
    const bx = cx - 32, by = cy;
    const gw = 42, gh = 36;
    const cp = gw * 0.45;
    return (
      <g>
        <path d={`M ${bx},${by-gh/2} Q ${bx+cp},${by} ${bx},${by+gh/2} Q ${bx+gw},${by+gh/2} ${bx+gw+gh/2},${by} Q ${bx+gw},${by-gh/2} ${bx},${by-gh/2} Z`}
          fill="#f8fbff" stroke={color} strokeWidth="2"/>
        <circle cx={bx+gw+gh/2+5} cy={by} r={5} fill="#fff" stroke={color} strokeWidth="2"/>
        <line x1={bx-16} y1={by-10} x2={bx+4} y2={by-10} stroke={color} strokeWidth="1.8"/>
        <line x1={bx-16} y1={by+10} x2={bx+4} y2={by+10} stroke={color} strokeWidth="1.8"/>
        <text x={bx-22} y={by-6} textAnchor="middle" fontSize="11" fill={color} fontWeight="700">p</text>
        <text x={bx-22} y={by+14} textAnchor="middle" fontSize="11" fill={color} fontWeight="700">q</text>
        <line x1={bx+gw+gh/2+10} y1={by} x2={bx+gw+gh/2+22} y2={by} stroke={color} strokeWidth="1.8"/>
        <text x={bx+gw+gh/2+30} y={by+4} textAnchor="middle" fontSize="10" fill={color} fontWeight="700">out</text>
      </g>
    );
  }

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Logic Gate Symbols — Standard Schematic Representations</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>

        {gates.map(({ name, color }, i) => {
          const panX = 14 + i * (GW + gap + 8);
          const panW = GW + 8;
          const cx = panX + panW / 2;
          const cy = 128;
          return (
            <g key={i}>
              <rect x={panX} y={10} width={panW} height={H-20} rx={5} fill="#fff" stroke="#ccd9ea"/>
              <rect x={panX} y={10} width={panW} height={28} rx={5} fill={color}/>
              <rect x={panX} y={30} width={panW} height={8} fill={color}/>
              <text x={panX+panW/2} y={27} textAnchor="middle" fontSize="13" fill="#fff" fontWeight="700">{name}</text>
              {name==='NOT'  && <GateNOT  cx={cx} cy={cy} color={color}/>}
              {name==='AND'  && <GateAND  cx={cx} cy={cy} color={color}/>}
              {name==='OR'   && <GateOR   cx={cx} cy={cy} color={color} xorExtra={false}/>}
              {name==='XOR'  && <GateOR   cx={cx} cy={cy} color={color} xorExtra={true}/>}
              {name==='NAND' && <GateNAND cx={cx} cy={cy} color={color}/>}
              {name==='NOR'  && <GateNOR  cx={cx} cy={cy} color={color}/>}
              {/* Label at bottom */}
              <rect x={panX+8} y={H-56} width={panW-16} height={30} rx={3}
                fill={name==='NOT'?'#f0f0f0':color==='#2E75B6'?'#EBF3FB':color==='#27ae60'?'#f0fff4':color==='#e07b00'?'#fff7ee':color==='#c0392b'?'#fff0f0':'#f5d0ff'}
                stroke={color} strokeWidth="1"/>
              <text x={panX+panW/2} y={H-42} textAnchor="middle" fontSize="10" fill={color} fontFamily="'Courier New',monospace" fontWeight="700">
                {name==='NOT'?'output = NOT p':name==='AND'?'p AND q':name==='OR'?'p OR q':name==='XOR'?'p XOR q':name==='NAND'?'NOT(p AND q)':'NOT(p OR q)'}
              </text>
              <text x={panX+panW/2} y={H-28} textAnchor="middle" fontSize="10" fill={color} fontFamily="'Courier New',monospace">
                {name==='NOT'?'= 1 - p':name==='AND'?'= p \u00b7 q':name==='OR'?'= p + q':name==='XOR'?'= p \u2295 q':name==='NAND'?'= \u00ac(p\u00b7q)':'= \u00ac(p+q)'}
              </text>
            </g>
          );
        })}

      </svg>
      <div style={S.dCaption}>Logic gates are hardware implementations of Boolean operations. NOT uses a triangle with an inversion bubble. AND has a flat back and rounded front. OR has a curved back giving a pointed output. XOR adds a second curved line to the OR body. NAND and NOR are AND and OR with a bubble on the output, producing the complemented result.</div>
    </div>
  );
}

// ── Diagram 3: Venn Diagrams for Set/Logic Operations ───────────
function DiagramVenn() {
  const W = 900, H = 260;
  const n = 6;
  const PW = (W - 28 - (n-1)*10) / n;
  const p0 = i => 14 + i*(PW+10);
  const r = 52, cx1off = -22, cx2off = 22, midY = 128;

  const vennOps = [
    { name:'AND (p ∧ q)',  color:'#2E75B6', bg:'#EBF3FB', // shade intersection only
      shade: (ox, oy) => (
        <clipPath id="vand">
          <circle cx={ox+cx1off} cy={oy} r={r}/>
        </clipPath>
      ),
      fill: (ox, oy) => (
        <circle cx={ox+cx2off} cy={oy} r={r} fill="#2E75B6" fillOpacity="0.55" clipPath="url(#vand)"/>
      ),
    },
    { name:'OR (p ∨ q)', color:'#27ae60',   // shade both
      fill: (ox, oy) => (
        <g>
          <circle cx={ox+cx1off} cy={oy} r={r} fill="#27ae60" fillOpacity="0.45"/>
          <circle cx={ox+cx2off} cy={oy} r={r} fill="#27ae60" fillOpacity="0.45"/>
        </g>
      ),
    },
    { name:'XOR (p ⊕ q)', color:'#e07b00',  // shade both minus intersection
      shade: (ox, oy) => (
        <clipPath id="vxor">
          <circle cx={ox+cx1off} cy={oy} r={r}/>
        </clipPath>
      ),
      fill: (ox, oy) => (
        <g>
          <circle cx={ox+cx1off} cy={oy} r={r} fill="#e07b00" fillOpacity="0.5"/>
          <circle cx={ox+cx2off} cy={oy} r={r} fill="#e07b00" fillOpacity="0.5"/>
          {/* white out intersection */}
          <circle cx={ox+cx2off} cy={oy} r={r} fill="white" fillOpacity="0.85" clipPath="url(#vxor)"/>
        </g>
      ),
    },
    { name:'NAND (¬(p∧q))', color:'#c0392b', // everything except intersection
      shade: (ox, oy) => (
        <clipPath id="vnand">
          <circle cx={ox+cx1off} cy={oy} r={r}/>
        </clipPath>
      ),
      fill: (ox, oy) => (
        <g>
          <rect x={ox-r-30} y={oy-r-10} width={PW-4} height={(r+10)*2} fill="#c0392b" fillOpacity="0.18"/>
          <circle cx={ox+cx2off} cy={oy} r={r} fill="white" fillOpacity="0.9" clipPath="url(#vnand)"/>
        </g>
      ),
    },
    { name:'NOR (¬(p∨q))', color:'#9b59b6',  // outside both circles
      fill: (ox, oy) => (
        <g>
          <rect x={ox-r-30} y={oy-r-10} width={PW-4} height={(r+10)*2} fill="#9b59b6" fillOpacity="0.18"/>
          <circle cx={ox+cx1off} cy={oy} r={r} fill="white" fillOpacity="0.9"/>
          <circle cx={ox+cx2off} cy={oy} r={r} fill="white" fillOpacity="0.9"/>
        </g>
      ),
    },
    { name:'NOT p (¬p)', color:'#555',  // outside left circle = complement of p
      fill: (ox, oy) => (
        <g>
          <rect x={ox-r-30} y={oy-r-10} width={PW-4} height={(r+10)*2} fill="#888" fillOpacity="0.18"/>
          <circle cx={ox+cx1off} cy={oy} r={r} fill="white" fillOpacity="0.9"/>
        </g>
      ),
    },
  ];

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Venn Diagram Representations of Logical Operations</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <defs>
          {vennOps.map(({ shade }, i) => shade && shade(0, 0))}
        </defs>

        {vennOps.map(({ name, color, fill, shade }, i) => {
          const px = p0(i);
          const ox = px + PW/2;
          const oy = midY;
          return (
            <g key={i}>
              <rect x={px} y={10} width={PW} height={H-20} rx={5} fill="#fff" stroke="#ccd9ea"/>
              {/* Defs per panel (clipPaths need unique IDs per panel) */}
              <defs>{shade && shade(ox, oy)}</defs>
              {/* Shading */}
              {fill(ox, oy)}
              {/* Circle outlines */}
              <circle cx={ox+cx1off} cy={oy} r={r} fill="none" stroke={color} strokeWidth="2"/>
              <circle cx={ox+cx2off} cy={oy} r={r} fill="none" stroke={color} strokeWidth="2"/>
              {/* Labels */}
              <text x={ox+cx1off-r+8} y={oy-r-6} fontSize="11" fill={color} fontWeight="700">p</text>
              <text x={ox+cx2off+r-16} y={oy-r-6} fontSize="11" fill={color} fontWeight="700">q</text>
              {/* Title */}
              <text x={ox} y={H-24} textAnchor="middle" fontSize="11" fill={color} fontWeight="700">{name}</text>
            </g>
          );
        })}

      </svg>
      <div style={S.dCaption}>Shaded regions show which part of the universe satisfies the operation. AND shades only the intersection. OR shades both circles. XOR shades both circles but removes the intersection. NAND and NOR shade the complement of AND and OR respectively. NOT p shades everything outside the left circle.</div>
    </div>
  );
}

// ── Diagram 4: Boolean Algebra Laws ─────────────────────────────
function DiagramBooleanLaws() {
  const W = 900, H = 420;
  const PW = (W - 42) / 2;
  const pL = 14, pR = pL + PW + 14;

  const lawsL = [
    { name:'Identity',       law1:'p ∧ 1 = p',       law2:'p ∨ 0 = p',       color:'#2E75B6', bg:'#EBF3FB', bc:'#2E75B6' },
    { name:'Null/Dominance', law1:'p ∧ 0 = 0',       law2:'p ∨ 1 = 1',       color:'#27ae60', bg:'#f0fff4', bc:'#27ae60' },
    { name:'Idempotent',     law1:'p ∧ p = p',        law2:'p ∨ p = p',       color:'#e07b00', bg:'#fff7ee', bc:'#e07b00' },
    { name:'Complement',     law1:'p ∧ ¬p = 0',       law2:'p ∨ ¬p = 1',      color:'#c0392b', bg:'#fff0f0', bc:'#c0392b' },
    { name:'Double Negation','law1':'¬(¬p) = p',      law2:'',                 color:'#9b59b6', bg:'#f5d0ff', bc:'#9b59b6' },
    { name:'Commutative',    law1:'p ∧ q = q ∧ p',   law2:'p ∨ q = q ∨ p',  color:'#1F3864', bg:'#e8eaf6', bc:'#1F3864' },
  ];

  const lawsR = [
    { name:'Associative',    law1:'(p∧q)∧r = p∧(q∧r)',  law2:'(p∨q)∨r = p∨(q∨r)', color:'#2E75B6', bg:'#EBF3FB', bc:'#2E75B6' },
    { name:'Distributive',   law1:'p∧(q∨r) = (p∧q)∨(p∧r)', law2:'p∨(q∧r) = (p∨q)∧(p∨r)', color:'#27ae60', bg:'#f0fff4', bc:'#27ae60' },
    { name:"De Morgan's",    law1:'¬(p∧q) = ¬p∨¬q',   law2:'¬(p∨q) = ¬p∧¬q', color:'#c0392b', bg:'#fff0f0', bc:'#c0392b' },
    { name:'Absorption',     law1:'p∧(p∨q) = p',       law2:'p∨(p∧q) = p',     color:'#e07b00', bg:'#fff7ee', bc:'#e07b00' },
    { name:'Consensus',      law1:'(p∧q)∨(¬p∧r)∨(q∧r) = (p∧q)∨(¬p∧r)', law2:'', color:'#9b59b6', bg:'#f5d0ff', bc:'#9b59b6' },
    { name:'Involution/XOR', law1:'p ⊕ p = 0',         law2:'p ⊕ ¬p = 1',      color:'#1F3864', bg:'#e8eaf6', bc:'#1F3864' },
  ];

  const rowH = 58;

  function LawRow({ x, pw, law, i }) {
    const { name, law1, law2, color, bg, bc } = law;
    const y = 36 + i * (rowH + 4);
    return (
      <g>
        <rect x={x+8} y={y} width={pw-16} height={rowH} rx={3} fill={bg} stroke={bc} strokeWidth="1"/>
        <text x={x+16} y={y+16} fontSize="11" fill={color} fontWeight="700">{name}</text>
        <text x={x+16} y={y+33} fontSize="11" fill="#333" fontFamily="'Courier New',monospace">{law1}</text>
        {law2 && <text x={x+16} y={y+50} fontSize="11" fill="#555" fontFamily="'Courier New',monospace">{law2}</text>}
      </g>
    );
  }

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Boolean Algebra Laws — Identities, De Morgan, Distributive, and More</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>

        {/* Left panel */}
        <rect x={pL} y={10} width={PW} height={H-20} rx={5} fill="#fff" stroke="#ccd9ea"/>
        <text x={pL+PW/2} y={28} textAnchor="middle" fontSize="14" fill="#1F3864" fontWeight="700">Fundamental Laws</text>
        {lawsL.map((law, i) => <LawRow key={i} x={pL} pw={PW} law={law} i={i}/>)}

        {/* Right panel */}
        <rect x={pR} y={10} width={PW} height={H-20} rx={5} fill="#fff" stroke="#ccd9ea"/>
        <text x={pR+PW/2} y={28} textAnchor="middle" fontSize="14" fill="#1F3864" fontWeight="700">Structural Laws</text>
        {lawsR.map((law, i) => <LawRow key={i} x={pR} pw={PW} law={law} i={i}/>)}

      </svg>
      <div style={S.dCaption}>Boolean algebra obeys the same duality principle throughout: every law has a dual obtained by swapping AND with OR and 0 with 1. De Morgan's laws are especially important — they let you push a negation through a conjunction or disjunction by flipping the connective. The distributive laws differ from ordinary arithmetic: both AND over OR and OR over AND distribute.</div>
    </div>
  );
}

// ── Diagram 5: Normal Forms & Karnaugh Map ───────────────────────
function DiagramNormalForms() {
  const W = 900, H = 400;
  const LP = 14, LW = 400;
  const RP = LP + LW + 18, RW = W - RP - 14;

  // Left: DNF and CNF parse-tree style
  // Example formula: F = (p ∧ ¬q) ∨ (¬p ∧ q) = XOR

  // Right: 2-variable Karnaugh map for F = p XOR q

  const kmap = [
    { row:0, col:0, pval:0, qval:0, val:0 },
    { row:0, col:1, pval:0, qval:1, val:1 },
    { row:1, col:0, pval:1, qval:0, val:1 },
    { row:1, col:1, pval:1, qval:1, val:0 },
  ];

  const kx = RP + 40, ky = 46, cw = 54, ch = 54;

  // 3-variable K-map for F = p∧q∨¬p∧r (majority-style, 3 vars)
  const kmap3 = [
    // row = r,  col = pq
    // Gray code: pq = 00,01,11,10
    [0, 1, 1, 0], // r=0
    [0, 1, 1, 1], // r=1
  ];
  const pqLabels = ['00','01','11','10'];
  const k3x = RP + 24, k3y = 228, c3w = 44, c3h = 40;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Normal Forms — DNF, CNF, and Karnaugh Map Simplification</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>

        {/* Left panel */}
        <rect x={LP} y={10} width={LW} height={H-20} rx={5} fill="#fff" stroke="#ccd9ea"/>
        <text x={LP+LW/2} y={28} textAnchor="middle" fontSize="14" fill="#1F3864" fontWeight="700">DNF and CNF Forms</text>
        <text x={LP+LW/2} y={44} textAnchor="middle" fontSize="11" fill="#555">Example: F = (p ∧ ¬q) ∨ (¬p ∧ q)  [XOR]</text>

        {/* DNF box */}
        <rect x={LP+10} y={52} width={LW-20} height={80} rx={3} fill="#EBF3FB" stroke="#2E75B6" strokeWidth="1.5"/>
        <text x={LP+18} y={68} fontSize="12" fill="#2E75B6" fontWeight="700">DNF — Disjunctive Normal Form (Sum of Products)</text>
        <text x={LP+18} y={84} fontSize="11" fill="#333" fontFamily="'Courier New',monospace">F = (p ∧ ¬q) ∨ (¬p ∧ q)</text>
        <text x={LP+18} y={100} fontSize="11" fill="#555">Each clause is a minterm: a conjunction of literals.</text>
        <text x={LP+18} y={114} fontSize="11" fill="#555">OR of all minterms where F = 1 (truth-table rows).</text>
        <text x={LP+18} y={126} fontSize="10" fill="#2E75B6" fontFamily="'Courier New',monospace">F = m1 ∨ m2  where m1=(p∧¬q), m2=(¬p∧q)</text>

        {/* CNF box */}
        <rect x={LP+10} y={140} width={LW-20} height={80} rx={3} fill="#f0fff4" stroke="#27ae60" strokeWidth="1.5"/>
        <text x={LP+18} y={156} fontSize="12" fill="#27ae60" fontWeight="700">CNF — Conjunctive Normal Form (Product of Sums)</text>
        <text x={LP+18} y={172} fontSize="11" fill="#333" fontFamily="'Courier New',monospace">F = (p ∨ q) ∧ (¬p ∨ ¬q)</text>
        <text x={LP+18} y={188} fontSize="11" fill="#555">Each clause is a maxterm: a disjunction of literals.</text>
        <text x={LP+18} y={204} fontSize="11" fill="#555">AND of all maxterms where F = 0 (negated rows).</text>
        <text x={LP+18} y={216} fontSize="10" fill="#27ae60" fontFamily="'Courier New',monospace">F = M0 ∧ M3  where M0=(p∨q), M3=(¬p∨¬q)</text>

        {/* Conversion note */}
        <rect x={LP+10} y={228} width={LW-20} height={54} rx={3} fill="#fff7ee" stroke="#e07b00" strokeWidth="1"/>
        <text x={LP+18} y={244} fontSize="11" fill="#e07b00" fontWeight="700">Converting between forms:</text>
        <text x={LP+18} y={260} fontSize="11" fill="#444">DNF to CNF: apply De Morgan + distribution</text>
        <text x={LP+18} y={276} fontSize="11" fill="#444">Any formula can be put into both DNF and CNF</text>

        {/* Satisfiability note */}
        <rect x={LP+10} y={290} width={LW-20} height={96} rx={3} fill="#f5d0ff" stroke="#9b59b6" strokeWidth="1"/>
        <text x={LP+18} y={306} fontSize="12" fill="#9b59b6" fontWeight="700">Satisfiability and Completeness</text>
        <text x={LP+18} y={322} fontSize="11" fill="#444">Tautology: F = 1 for all inputs (e.g. p ∨ ¬p)</text>
        <text x={LP+18} y={338} fontSize="11" fill="#444">Contradiction: F = 0 for all inputs (e.g. p ∧ ¬p)</text>
        <text x={LP+18} y={354} fontSize="11" fill="#444">Satisfiable: F = 1 for at least one input</text>
        <text x={LP+18} y={370} fontSize="11" fill="#555">SAT problem: deciding satisfiability is NP-complete</text>

        {/* Right panel */}
        <rect x={RP} y={10} width={RW} height={H-20} rx={5} fill="#fff" stroke="#ccd9ea"/>
        <text x={RP+RW/2} y={28} textAnchor="middle" fontSize="14" fill="#1F3864" fontWeight="700">Karnaugh Map Simplification</text>
        <text x={RP+RW/2} y={44} textAnchor="middle" fontSize="11" fill="#555">2-variable K-map: F = p XOR q</text>

        {/* K-map axis labels */}
        <text x={kx+cw} y={ky-6} textAnchor="middle" fontSize="11" fill="#1F3864" fontWeight="700">q=0</text>
        <text x={kx+cw+cw} y={ky-6} textAnchor="middle" fontSize="11" fill="#1F3864" fontWeight="700">q=1</text>
        <text x={kx-14} y={ky+ch/2+8} textAnchor="end" fontSize="11" fill="#1F3864" fontWeight="700">p=0</text>
        <text x={kx-14} y={ky+ch+ch/2+8} textAnchor="end" fontSize="11" fill="#1F3864" fontWeight="700">p=1</text>

        {kmap.map(({ row, col, pval, qval, val }) => {
          const cx2 = kx + cw + col*cw;
          const cy2 = ky + row*ch;
          const isOne = val === 1;
          return (
            <g key={`${row}-${col}`}>
              <rect x={cx2} y={cy2} width={cw-2} height={ch-2} rx={2}
                fill={isOne ? '#EBF3FB' : '#fff'} stroke={isOne ? '#2E75B6' : '#ccd9ea'} strokeWidth={isOne?2:1}/>
              <text x={cx2+(cw-2)/2} y={cy2+(ch-2)/2+5} textAnchor="middle"
                fontSize="18" fill={isOne?'#2E75B6':'#ccc'} fontWeight="700">{val}</text>
              <text x={cx2+(cw-2)/2} y={cy2+(ch-2)/2+20} textAnchor="middle"
                fontSize="9" fill="#aaa">({pval},{qval})</text>
            </g>
          );
        })}

        {/* XOR K-map: no two adjacent 1s can be grouped — explains why XOR cannot be simplified */}
        <text x={RP+RW/2} y={ky+2*ch+22} textAnchor="middle" fontSize="10" fill="#c0392b">1s are not adjacent — XOR cannot simplify further</text>

        {/* 3-variable K-map */}
        <text x={RP+RW/2} y={ky+2*ch+42} textAnchor="middle" fontSize="12" fill="#1F3864" fontWeight="700">3-variable K-map: F = (p∧q) ∨ (¬p∧r)</text>
        <text x={RP+RW/2} y={ky+2*ch+58} textAnchor="middle" fontSize="10" fill="#555">Gray-code column order ensures adjacent squares differ by 1 bit</text>

        {/* pq axis */}
        {pqLabels.map((lbl, ci) => (
          <text key={ci} x={k3x+c3w+ci*c3w+c3w/2} y={k3y-6} textAnchor="middle"
            fontSize="10" fill="#1F3864" fontWeight="700">pq={lbl}</text>
        ))}
        <text x={k3x-6} y={k3y+c3h/2+6} textAnchor="end" fontSize="10" fill="#1F3864" fontWeight="700">r=0</text>
        <text x={k3x-6} y={k3y+c3h+c3h/2+6} textAnchor="end" fontSize="10" fill="#1F3864" fontWeight="700">r=1</text>

        {kmap3.map((row, ri) =>
          row.map((val, ci) => {
            const rx2 = k3x + c3w + ci*c3w;
            const ry2 = k3y + ri*c3h;
            const isOne = val === 1;
            const grpColor = (ri===0&&(ci===1||ci===2)) ? '#27ae60' : (ri===1&&(ci===2||ci===3)) ? '#e07b00' : null;
            return (
              <g key={`k3-${ri}-${ci}`}>
                <rect x={rx2} y={ry2} width={c3w-2} height={c3h-2} rx={2}
                  fill={isOne?(grpColor?grpColor+'33':'#EBF3FB'):'#fff'}
                  stroke={isOne?(grpColor||'#2E75B6'):'#ccd9ea'} strokeWidth={isOne?2:1}/>
                <text x={rx2+(c3w-2)/2} y={ry2+(c3h-2)/2+5} textAnchor="middle"
                  fontSize="15" fill={isOne?(grpColor||'#2E75B6'):'#ccc'} fontWeight="700">{val}</text>
              </g>
            );
          })
        )}

        {/* Group annotations */}
        <rect x={k3x+c3w} y={k3y} width={c3w*2-2} height={c3h-2} rx={4}
          fill="none" stroke="#27ae60" strokeWidth="2" strokeDasharray="4,3"/>
        <text x={k3x+c3w+c3w} y={k3y+c3h+14} textAnchor="middle" fontSize="10" fill="#27ae60" fontWeight="700">p∧q (r=0)</text>
        <rect x={k3x+c3w*2} y={k3y+c3h} width={c3w*2-2} height={c3h-2} rx={4}
          fill="none" stroke="#e07b00" strokeWidth="2" strokeDasharray="4,3"/>
        <text x={k3x+c3w*3} y={k3y+2*c3h+14} textAnchor="middle" fontSize="10" fill="#e07b00" fontWeight="700">¬p∧r</text>

        <text x={RP+RW/2} y={k3y+2*c3h+32} textAnchor="middle" fontSize="11" fill="#1F3864" fontWeight="700">Simplified: F = (p∧q) ∨ (¬p∧r)</text>

      </svg>
      <div style={S.dCaption}>DNF (sum of products) and CNF (product of sums) are canonical forms any Boolean formula can be converted to. A Karnaugh map arranges truth-table entries in a Gray-code grid so adjacent cells differ in exactly one variable; grouping adjacent 1s (in powers of 2) identifies the largest prime implicants and gives the minimal DNF expression.</div>
    </div>
  );
}

// ── Diagram 6: Logical Implication & Inference Rules ────────────
function DiagramInference() {
  const W = 900, H = 380;
  const LP = 14, LW = 380;
  const RP = LP + LW + 18, RW = W - RP - 14;

  // Left: implication truth table + equivalences
  const implRows = [
    { p:0, q:0, imp:1, bic:1 },
    { p:0, q:1, imp:1, bic:0 },
    { p:1, q:0, imp:0, bic:0 },
    { p:1, q:1, imp:1, bic:1 },
  ];

  const rowH = 28, hdrH = 32;
  const tableX = LP + 16, tableY = 40;
  const colWs = [36, 36, 60, 60, 70, 70]; // p q p->q p<->q ¬p∨q p=q equivalent
  const headers = ['p','q','p→q','p↔q','¬p∨q','equiv?'];

  // Right: inference rules
  const rules = [
    { name:'Modus Ponens',    latin:'MP',
      premise1:'p → q',  premise2:'p',        concl:'q',
      note:'If p implies q, and p is true, then q.',
      color:'#2E75B6', bg:'#EBF3FB', bc:'#2E75B6' },
    { name:'Modus Tollens',   latin:'MT',
      premise1:'p → q',  premise2:'¬q',       concl:'¬p',
      note:'If p implies q, and q is false, then p is false.',
      color:'#27ae60', bg:'#f0fff4', bc:'#27ae60' },
    { name:'Hypothetical Syllogism', latin:'HS',
      premise1:'p → q',  premise2:'q → r',    concl:'p → r',
      note:'Implication is transitive.',
      color:'#e07b00', bg:'#fff7ee', bc:'#e07b00' },
    { name:'Disjunctive Syllogism',  latin:'DS',
      premise1:'p ∨ q',  premise2:'¬p',       concl:'q',
      note:'If one disjunct is false, the other holds.',
      color:'#c0392b', bg:'#fff0f0', bc:'#c0392b' },
    { name:'Conjunction',    latin:'Conj',
      premise1:'p',       premise2:'q',        concl:'p ∧ q',
      note:'Combine two truths into a conjunction.',
      color:'#9b59b6', bg:'#f5d0ff', bc:'#9b59b6' },
    { name:'Simplification',  latin:'Simp',
      premise1:'p ∧ q',  premise2:'',          concl:'p',
      note:'From a conjunction, extract one conjunct.',
      color:'#1F3864', bg:'#e8eaf6', bc:'#1F3864' },
  ];

  const ruleH = 54;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Logical Implication, Biconditional, and Inference Rules</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>

        {/* Left panel */}
        <rect x={LP} y={10} width={LW} height={H-20} rx={5} fill="#fff" stroke="#ccd9ea"/>
        <text x={LP+LW/2} y={28} textAnchor="middle" fontSize="14" fill="#1F3864" fontWeight="700">Implication and Biconditional Truth Tables</text>

        {/* Table */}
        {/* Header */}
        <rect x={tableX} y={tableY} width={LW-32} height={hdrH} rx={3} fill="#2E75B6"/>
        {(() => {
          let xOff = tableX;
          return headers.map((h, i) => {
            const w = colWs[i];
            const el = (
              <text key={i} x={xOff + w/2} y={tableY+hdrH/2+4} textAnchor="middle"
                fontSize="11" fill="#fff" fontWeight="700" fontFamily="'Courier New',monospace">{h}</text>
            );
            xOff += w;
            return el;
          });
        })()}

        {/* Rows */}
        {implRows.map((row, ri) => {
          const vals = [row.p, row.q, row.imp, row.bic, row.imp, row.bic===1?'=':'?'];
          let xOff = tableX;
          const bgClr = ri%2===0 ? '#f8fbff' : '#fff';
          const rowElements = [];
          rowElements.push(
            <rect key={`bg-${ri}`} x={tableX} y={tableY+hdrH+ri*rowH} width={LW-32} height={rowH}
              fill={bgClr} stroke="#eee" strokeWidth="0.8"/>
          );
          vals.forEach((v, ci) => {
            const w = colWs[ci];
            const isOut = ci >= 2;
            const numVal = typeof v === 'number' ? v : null;
            const txtColor = numVal===null ? '#888' : (ci<2 ? '#555' : (numVal===1?'#27ae60':'#c0392b'));
            rowElements.push(
              <text key={`${ri}-${ci}`} x={xOff+w/2} y={tableY+hdrH+ri*rowH+rowH/2+4}
                textAnchor="middle" fontSize="12" fill={txtColor}
                fontFamily="'Courier New',monospace" fontWeight={isOut?'700':'400'}>{v}</text>
            );
            xOff += w;
          });
          return rowElements;
        })}

        {/* Key observations */}
        <rect x={LP+10} y={tableY+hdrH+4*rowH+12} width={LW-20} height={56} rx={3} fill="#EBF3FB" stroke="#2E75B6" strokeWidth="1"/>
        <text x={LP+18} y={tableY+hdrH+4*rowH+28} fontSize="11" fill="#2E75B6" fontWeight="700">Key: p→q is false ONLY when p=1 and q=0</text>
        <text x={LP+18} y={tableY+hdrH+4*rowH+44} fontSize="11" fill="#444">p→q is equivalent to ¬p ∨ q  (used in proofs)</text>
        <text x={LP+18} y={tableY+hdrH+4*rowH+58} fontSize="10" fill="#555">p↔q = (p→q) ∧ (q→p)  (true iff same truth value)</text>

        {/* Contrapositive */}
        <rect x={LP+10} y={tableY+hdrH+4*rowH+76} width={LW-20} height={80} rx={3} fill="#fff7ee" stroke="#e07b00" strokeWidth="1"/>
        <text x={LP+18} y={tableY+hdrH+4*rowH+92} fontSize="11" fill="#e07b00" fontWeight="700">Important Equivalences:</text>
        <text x={LP+18} y={tableY+hdrH+4*rowH+108} fontSize="11" fill="#333" fontFamily="'Courier New',monospace">p→q  ≡  ¬q→¬p    (contrapositive)</text>
        <text x={LP+18} y={tableY+hdrH+4*rowH+124} fontSize="11" fill="#333" fontFamily="'Courier New',monospace">p→q  ≢  q→p      (converse ≠ original)</text>
        <text x={LP+18} y={tableY+hdrH+4*rowH+140} fontSize="11" fill="#333" fontFamily="'Courier New',monospace">p→q  ≢  ¬p→¬q   (inverse ≠ original)</text>

        {/* Right panel */}
        <rect x={RP} y={10} width={RW} height={H-20} rx={5} fill="#fff" stroke="#ccd9ea"/>
        <text x={RP+RW/2} y={28} textAnchor="middle" fontSize="14" fill="#1F3864" fontWeight="700">Rules of Inference</text>

        {rules.map(({ name, latin, premise1, premise2, concl, note, color, bg, bc }, i) => {
          const y = 36 + i * (ruleH + 6);
          return (
            <g key={i}>
              <rect x={RP+10} y={y} width={RW-20} height={ruleH} rx={3} fill={bg} stroke={bc} strokeWidth="1"/>
              {/* Name and latin abbrev */}
              <text x={RP+18} y={y+15} fontSize="11" fill={color} fontWeight="700">{name}</text>
              <text x={RP+RW-18} y={y+15} textAnchor="end" fontSize="10" fill={color} fontFamily="'Courier New',monospace">[{latin}]</text>
              {/* Premises / conclusion */}
              <text x={RP+18} y={y+30} fontSize="11" fill="#333" fontFamily="'Courier New',monospace">
                {premise2 ? premise1 + ',  ' + premise2 + '  ⊢  ' + concl : premise1 + '  ⊢  ' + concl}
              </text>
              <text x={RP+18} y={y+46} fontSize="10" fill="#666">{note}</text>
            </g>
          );
        })}

      </svg>
      <div style={S.dCaption}>The conditional p→q (implication) is false only when the hypothesis p is true but the conclusion q is false — "a true premise cannot lead to a false conclusion." The contrapositive is logically equivalent to the original. Rules of inference (Modus Ponens, Modus Tollens, etc.) are the valid argument patterns that underpin all formal proofs in mathematics and logic.</div>
    </div>
  );
}

// ── Diagram 7: Predicate Logic & Quantifiers ─────────────────────
function DiagramPredicateLogic() {
  const W = 900, H = 320;
  const PW = (W - 42) / 2;
  const pL = 14, pR = pL + PW + 14;
  const RW = W - pR - 14;

  // Left: universal vs existential quantifier with domain illustration
  const domainItems = [
    { x:60,  y:90,  val:true,  label:'x₁' },
    { x:120, y:70,  val:true,  label:'x₂' },
    { x:180, y:100, val:true,  label:'x₃' },
    { x:100, y:140, val:true,  label:'x₄' },
    { x:160, y:150, val:true,  label:'x₅' },
  ];
  const domainItemsEx = [
    { x:60,  y:90,  val:false, label:'x₁' },
    { x:120, y:70,  val:true,  label:'x₂' },
    { x:180, y:100, val:false, label:'x₃' },
    { x:100, y:140, val:false, label:'x₄' },
    { x:160, y:150, val:false, label:'x₅' },
  ];

  // Right: quantifier negation rules + scope
  const negRules = [
    { rule:'¬(∀x P(x))',  equiv:'∃x ¬P(x)', note:'Not all x satisfy P = some x do not',   color:'#2E75B6', bg:'#EBF3FB', bc:'#2E75B6' },
    { rule:'¬(∃x P(x))',  equiv:'∀x ¬P(x)', note:'No x satisfies P = all x fail P',        color:'#c0392b', bg:'#fff0f0', bc:'#c0392b' },
    { rule:'∀x∀y P(x,y)', equiv:'∀y∀x P(x,y)', note:'Order of same-type quantifiers can swap', color:'#27ae60', bg:'#f0fff4', bc:'#27ae60' },
    { rule:'∃x∃y P(x,y)', equiv:'∃y∃x P(x,y)', note:'Existentials of same type can swap too', color:'#e07b00', bg:'#fff7ee', bc:'#e07b00' },
    { rule:'∃x∀y P(x,y)', equiv:'≠ ∀y∃x P(x,y)', note:'Mixed order CANNOT be swapped in general', color:'#9b59b6', bg:'#f5d0ff', bc:'#9b59b6' },
  ];

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Predicate Logic — Universal and Existential Quantifiers</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>

        {/* Left panel */}
        <rect x={pL} y={10} width={PW} height={H-20} rx={5} fill="#fff" stroke="#ccd9ea"/>
        <text x={pL+PW/2} y={28} textAnchor="middle" fontSize="14" fill="#1F3864" fontWeight="700">Universal (∀) vs Existential (∃)</text>

        {/* Universal quantifier block */}
        <rect x={pL+10} y={36} width={PW/2-16} height={H-56} rx={3} fill="#EBF3FB" stroke="#2E75B6" strokeWidth="1.5"/>
        <text x={pL+10+PW/4-8} y={52} textAnchor="middle" fontSize="18" fill="#2E75B6" fontWeight="700">∀x P(x)</text>
        <text x={pL+10+PW/4-8} y={68} textAnchor="middle" fontSize="10" fill="#555">"For ALL x, P(x) holds"</text>
        {/* Domain oval */}
        <ellipse cx={pL+10+PW/4-8} cy={130} rx={90} ry={60} fill="#EBF3FB" fillOpacity="0.5" stroke="#2E75B6" strokeWidth="1" strokeDasharray="4,3"/>
        {domainItems.map(({ x, y, val, label }, i) => (
          <g key={i}>
            <circle cx={pL+x-20} cy={y} r={10} fill="#2E75B6" fillOpacity="0.7" stroke="#2E75B6" strokeWidth="1.5"/>
            <text x={pL+x-20} y={y+4} textAnchor="middle" fontSize="9" fill="#fff" fontWeight="700">✓</text>
            <text x={pL+x-20} y={y+20} textAnchor="middle" fontSize="9" fill="#2E75B6">{label}</text>
          </g>
        ))}
        <text x={pL+10+PW/4-8} y={208} textAnchor="middle" fontSize="10" fill="#2E75B6" fontWeight="700">ALL elements satisfy P</text>
        <rect x={pL+18} y={222} width={PW/2-32} height={34} rx={2} fill="#2E75B6" fillOpacity="0.1" stroke="#2E75B6" strokeWidth="1"/>
        <text x={pL+10+PW/4-8} y={235} textAnchor="middle" fontSize="10" fill="#2E75B6" fontFamily="'Courier New',monospace">True if P(x) true</text>
        <text x={pL+10+PW/4-8} y={249} textAnchor="middle" fontSize="10" fill="#2E75B6" fontFamily="'Courier New',monospace">for every x in domain</text>
        <text x={pL+10+PW/4-8} y={276} textAnchor="middle" fontSize="10" fill="#555">Falsified by ONE counterexample</text>

        {/* Existential quantifier block */}
        <rect x={pL+PW/2+2} y={36} width={PW/2-16} height={H-56} rx={3} fill="#f0fff4" stroke="#27ae60" strokeWidth="1.5"/>
        <text x={pL+PW/2+2+PW/4-8} y={52} textAnchor="middle" fontSize="18" fill="#27ae60" fontWeight="700">∃x P(x)</text>
        <text x={pL+PW/2+2+PW/4-8} y={68} textAnchor="middle" fontSize="10" fill="#555">"SOME x satisfies P(x)"</text>
        <ellipse cx={pL+PW/2+2+PW/4-8} cy={130} rx={90} ry={60} fill="#f0fff4" fillOpacity="0.5" stroke="#27ae60" strokeWidth="1" strokeDasharray="4,3"/>
        {domainItemsEx.map(({ x, y, val, label }, i) => (
          <g key={i}>
            <circle cx={pL+PW/2+x-10} cy={y} r={10}
              fill={val?'#27ae60':'#eee'} fillOpacity="0.9"
              stroke={val?'#27ae60':'#ccc'} strokeWidth="1.5"/>
            <text x={pL+PW/2+x-10} y={y+4} textAnchor="middle" fontSize="9"
              fill={val?'#fff':'#aaa'} fontWeight="700">{val?'✓':'✗'}</text>
            <text x={pL+PW/2+x-10} y={y+20} textAnchor="middle" fontSize="9"
              fill={val?'#27ae60':'#aaa'}>{label}</text>
          </g>
        ))}
        <text x={pL+PW/2+2+PW/4-8} y={208} textAnchor="middle" fontSize="10" fill="#27ae60" fontWeight="700">AT LEAST ONE satisfies P</text>
        <rect x={pL+PW/2+10} y={222} width={PW/2-32} height={34} rx={2} fill="#27ae60" fillOpacity="0.1" stroke="#27ae60" strokeWidth="1"/>
        <text x={pL+PW/2+2+PW/4-8} y={235} textAnchor="middle" fontSize="10" fill="#27ae60" fontFamily="'Courier New',monospace">True if P(x) true</text>
        <text x={pL+PW/2+2+PW/4-8} y={249} textAnchor="middle" fontSize="10" fill="#27ae60" fontFamily="'Courier New',monospace">for at least one x</text>
        <text x={pL+PW/2+2+PW/4-8} y={276} textAnchor="middle" fontSize="10" fill="#555">Proved by ONE witness</text>

        {/* Right panel */}
        <rect x={pR} y={10} width={RW} height={H-20} rx={5} fill="#fff" stroke="#ccd9ea"/>
        <text x={pR+RW/2} y={28} textAnchor="middle" fontSize="14" fill="#1F3864" fontWeight="700">Quantifier Negation and Order</text>

        {negRules.map(({ rule, equiv, note, color, bg, bc }, i) => {
          const y = 36 + i * 52;
          return (
            <g key={i}>
              <rect x={pR+10} y={y} width={RW-20} height={46} rx={3} fill={bg} stroke={bc} strokeWidth="1"/>
              <text x={pR+18} y={y+16} fontSize="12" fill={color} fontFamily="'Courier New',monospace" fontWeight="700">{rule}  ≡  {equiv}</text>
              <text x={pR+18} y={y+33} fontSize="10" fill="#444">{note}</text>
            </g>
          );
        })}

        {/* Scope reminder */}
        <rect x={pR+10} y={36+5*52+4} width={RW-20} height={H-36-5*52-4-20} rx={3} fill="#e8eaf6" stroke="#1F3864" strokeWidth="1"/>
        <text x={pR+18} y={36+5*52+20} fontSize="11" fill="#1F3864" fontWeight="700">Predicate vs Proposition</text>
        <text x={pR+18} y={36+5*52+36} fontSize="11" fill="#444">Proposition: fixed truth value (p is 0 or 1)</text>
        <text x={pR+18} y={36+5*52+50} fontSize="11" fill="#444">Predicate P(x): truth depends on x</text>
        <text x={pR+18} y={36+5*52+64} fontSize="10" fill="#555">Quantifier binds variable and produces a proposition</text>

      </svg>
      <div style={S.dCaption}>The universal quantifier ∀ asserts a property holds for every element of a domain; it is falsified by a single counterexample. The existential quantifier ∃ asserts at least one witness exists; it is proved by exhibiting one. De Morgan's laws extend to quantifiers: negating ∀ produces ∃ and vice versa. The order of mixed quantifiers (∀∃ vs ∃∀) is in general not interchangeable.</div>
    </div>
  );
}

// ── Main ─────────────────────────────────────────────────────────
export default function LogicBooleanAlgebra() {
  return (
    <div style={S.wrapper}>
      <h1 style={S.h1}>Logic and Boolean Algebra in Discrete Mathematics</h1>
      <p style={S.p}>Logic is the formal study of valid reasoning. Boolean algebra, developed by George Boole in 1854, provides the algebraic rules for manipulating logical expressions — the same rules that underlie every digital circuit and programming language. Propositional logic deals with fixed-truth-value statements connected by AND, OR, NOT and other connectives. Predicate logic extends this with quantifiers (∀ "for all", ∃ "there exists") to reason about objects and their properties. Together they form the foundation of mathematical proof, circuit design, database query languages, and formal verification.</p>

      <InfoBox title="Core Idea: Every Boolean expression has a unique truth table and can be put into canonical form" items={[
        "Proposition: a statement with a definite truth value (0 = false, 1 = true)",
        "Connectives: ¬ (NOT), ∧ (AND), ∨ (OR), → (implies), ↔ (iff), ⊕ (XOR)",
        "Truth table: exhaustively lists the output for every combination of input values",
        "Boolean algebra: algebraic rules (identity, De Morgan, distribution) for simplifying expressions",
        "Normal forms: any formula can be written as DNF (sum of products) or CNF (product of sums)",
        "Predicate logic: extends propositions with variables, predicates P(x), and quantifiers ∀, ∃",
      ]}/>

      <h2 style={S.h2}>Truth Tables for the Basic Connectives</h2>
      <DiagramTruthTables/>
      <Table2 rows={[
        ["NOT (¬p, negation)",    "Flips truth value: ¬0=1, ¬1=0\nOnly unary (one-input) connective in standard logic"],
        ["AND (p∧q, conjunction)","1 iff both inputs are 1; 0 otherwise\nMultiplication in {0,1}: p·q"],
        ["OR (p∨q, disjunction)", "1 if at least one input is 1\nAddition in {0,1} with 1+1=1: p+q"],
        ["XOR (p⊕q, exclusive or)","1 iff inputs differ; 0 iff inputs are equal\nAddition mod 2: p+q mod 2; also written p⊕q"],
        ["NAND (¬(p∧q))",        "0 iff both inputs are 1; functionally complete alone\nNAND alone can implement any Boolean function"],
        ["NOR (¬(p∨q))",         "1 iff both inputs are 0; also functionally complete\nUsed in CMOS logic and hardware design"],
        ["XNOR / biconditional", "1 iff inputs are equal (both 0 or both 1)\np↔q in logic; used for equality testing in circuits"],
      ]}/>

      <h2 style={S.h2}>Logic Gate Symbols</h2>
      <DiagramGates/>
      <Table2 rows={[
        ["Gate vs connective",   "Logic gates are physical implementations of Boolean connectives\nGate symbols are standard (IEEE/IEC) schematic shorthand"],
        ["Inversion bubble",     "Small circle (bubble) on output = inversion/NOT applied\nPresent on NAND, NOR, XNOR, and inverter outputs"],
        ["Functional completeness","NAND alone (or NOR alone) suffices to build any gate\nAll other gates expressible as combinations of NANDs"],
        ["Fan-in / fan-out",     "Fan-in: number of inputs a gate accepts\nFan-out: number of gate inputs one output can drive"],
        ["Universal gates",      "NAND: ¬p = p NAND p;  p∧q = (p NAND q) NAND (p NAND q)\nNOR similarly universal — used in CMOS technology"],
      ]}/>

      <h2 style={S.h2}>Venn Diagram Interpretations</h2>
      <DiagramVenn/>
      <Table2 rows={[
        ["AND = intersection",   "p∧q: shaded region belongs to both sets\nAnalogue of set intersection A∩B"],
        ["OR = union",           "p∨q: shaded region belongs to at least one set\nAnalogue of set union A∪B"],
        ["XOR = symmetric diff", "p⊕q: shaded region is in exactly one set\nAnalogue of symmetric difference A△B"],
        ["NOT = complement",     "¬p: shaded region is outside the circle for p\nAnalogue of set complement Aᶜ"],
        ["NAND / NOR",           "NAND shades everything outside the intersection\nNOR shades only what is outside both circles"],
        ["Set-logic duality",    "Boolean algebra and set algebra share identical laws\nElements {0,1} vs subsets; ∧/∩, ∨/∪, ¬/complement"],
      ]}/>

      <h2 style={S.h2}>Boolean Algebra Laws</h2>
      <DiagramBooleanLaws/>
      <Table2 rows={[
        ["Identity laws",        "p∧1 = p  and  p∨0 = p\n1 is identity for AND; 0 is identity for OR"],
        ["Null laws",            "p∧0 = 0  and  p∨1 = 1\n0 dominates AND; 1 dominates OR"],
        ["Idempotent laws",      "p∧p = p  and  p∨p = p\nBoolean multiplication and addition are idempotent"],
        ["Complement laws",      "p∧¬p = 0 (contradiction) and p∨¬p = 1 (tautology)\nFoundation of proof by contradiction and excluded middle"],
        ["De Morgan's laws",     "¬(p∧q) = ¬p∨¬q  and  ¬(p∨q) = ¬p∧¬q\nNegation distributes through AND/OR while swapping the connective"],
        ["Distributive laws",    "p∧(q∨r) = (p∧q)∨(p∧r)  and  p∨(q∧r) = (p∨q)∧(p∨r)\nBoth AND over OR and OR over AND distribute"],
        ["Absorption laws",      "p∧(p∨q) = p  and  p∨(p∧q) = p\nUseful for simplifying redundant terms"],
        ["Duality principle",    "Every law has a dual: swap ∧↔∨ and 0↔1\nIf a law holds, its dual holds too"],
      ]}/>

      <h2 style={S.h2}>Normal Forms and Karnaugh Maps</h2>
      <DiagramNormalForms/>
      <Table2 rows={[
        ["Minterm",              "A conjunction of ALL variables (each possibly negated)\nFor n variables there are 2ⁿ minterms; minterm mᵢ is 1 only at row i"],
        ["Maxterm",              "A disjunction of ALL variables (each possibly negated)\nMaxterm Mᵢ is 0 only at row i; Mᵢ = ¬mᵢ"],
        ["DNF (sum of products)","OR of minterms where F=1: e.g. F = m1∨m3\nAlways exists; may not be minimal"],
        ["CNF (product of sums)","AND of maxterms where F=0: e.g. F = M0∧M2\nAlways exists; used in SAT solvers"],
        ["Karnaugh map",         "2D Gray-code grid of truth-table entries\nAdjacent cells differ in exactly one variable"],
        ["K-map grouping",       "Group 2ᵏ adjacent 1s to eliminate k variables\nLargest possible groups give prime implicants → minimal DNF"],
        ["SAT / UNSAT",          "SAT: at least one assignment makes F=1\nSAT is NP-complete; CNF-SAT is the canonical NP-complete problem"],
      ]}/>

      <h2 style={S.h2}>Implication, Biconditional, and Inference Rules</h2>
      <DiagramInference/>
      <Table2 rows={[
        ["Implication p→q",      "False only when p=1 and q=0 (true premise, false conclusion)\nEquivalent to ¬p∨q; read as 'if p then q'"],
        ["Contrapositive",       "p→q ≡ ¬q→¬p  (logically equivalent — same truth table)\nConverse q→p and inverse ¬p→¬q are NOT equivalent"],
        ["Biconditional p↔q",    "True iff p and q have the same truth value\nEquivalent to (p→q) ∧ (q→p); also written p iff q"],
        ["Modus Ponens",         "{p→q, p} ⊢ q  — the fundamental inference rule\nIf the conditional and its hypothesis hold, the conclusion holds"],
        ["Modus Tollens",        "{p→q, ¬q} ⊢ ¬p  — proof by contrapositive\nKnowing q failed and p→q, we deduce p must have failed"],
        ["Hypothetical Syllogism","{p→q, q→r} ⊢ p→r  — chaining implications\nImplication is transitive"],
        ["Disjunctive Syllogism","{p∨q, ¬p} ⊢ q  — elimination of a false disjunct\nFoundation of proof by cases / case analysis"],
        ["Argument validity",    "An argument is valid if premises make the conclusion unavoidable\nValidity is about form, not content; sound = valid + true premises"],
      ]}/>

      <h2 style={S.h2}>Predicate Logic and Quantifiers</h2>
      <DiagramPredicateLogic/>
      <Table2 rows={[
        ["Predicate P(x)",       "A function from domain D to {true, false}\nBecomes a proposition when x is assigned a value or quantified"],
        ["Universal quantifier", "∀x P(x): 'for every x in D, P(x) is true'\nFalsified by one counterexample x₀ with P(x₀)=false"],
        ["Existential quantifier","∃x P(x): 'there exists at least one x with P(x) true'\nProved by exhibiting a specific witness x₀"],
        ["Negating quantifiers", "¬∀x P(x) ≡ ∃x ¬P(x)  (De Morgan for quantifiers)\n¬∃x P(x) ≡ ∀x ¬P(x)"],
        ["Quantifier order",     "∀x∃y P(x,y) ≠ ∃y∀x P(x,y) in general\nExample: ∀x∃y(y>x) is true in ℤ; ∃y∀x(y>x) is false"],
        ["Nested quantifiers",   "∀x∀y = ∀y∀x and ∃x∃y = ∃y∃x (same-type can swap)\nMixed ∀∃ vs ∃∀ cannot swap — this is a critical distinction"],
        ["Prenex normal form",   "All quantifiers moved to the front: ∀x∃y... F(x,y,...)\nEvery first-order formula has an equivalent prenex form"],
        ["First-order logic",    "Predicate logic with ∀, ∃, and function/relation symbols\nGödel completeness: every valid FOL sentence is provable"],
      ]}/>

      <InfoBox title="Key Takeaway — Logic and Boolean Algebra Quick Reference" items={[
        "Truth table first: when in doubt, build the full truth table to verify any formula",
        "De Morgan's laws: ¬(p∧q) = ¬p∨¬q  and  ¬(p∨q) = ¬p∧¬q — memorise these",
        "Implication p→q is only false when the premise is true and conclusion is false",
        "Contrapositive (¬q→¬p) is equivalent to p→q; converse (q→p) is NOT",
        "DNF: OR of rows where output=1; CNF: AND of rows where output=0",
        "K-map: group 2ᵏ adjacent 1s to cancel k variables and get minimal expression",
        "NAND and NOR are each functionally complete — any circuit can be built from one gate type",
        "Quantifier negation: push ¬ inward, flip ∀ to ∃ (or ∃ to ∀), negate the predicate",
      ]}/>
    </div>
  );
}